var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import Email from './Email';
import PropTypes from 'prop-types';
import React from 'react';
import Text from './Text';

function DisableText(props, _ref) {
  var form = _ref.form;

  var subprops = _extends({}, props, {
    disabled: Boolean(form.get(props.disabled))
  });

  switch (props.subtype) {
    case 'email':
      return React.createElement(Email, subprops);
    default:
      return React.createElement(Text, subprops);
  }
}

DisableText.contextTypes = {
  form: PropTypes.object.isRequired
};

DisableText.propTypes = process.env.NODE_ENV !== "production" ? {
  disabled: PropTypes.string.isRequired,
  subtype: PropTypes.string
} : {};

export default DisableText;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/DisableText.js
// module id = 687
// module chunks = 0